import { render, staticRenderFns } from "./AppTableColumn.vue?vue&type=template&id=42e1aac1"
import script from "./AppTableColumn.vue?vue&type=script&lang=js"
export * from "./AppTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports